import React from 'react';
import { useHistory } from 'react-router-dom';
import ScreenLayout from 'components/ScreenLayout';
import AddOnOptionsContent from './components';
// import MobileFooter from 'components/MobileFooter';

const AddOnOptionsScreen: React.FC = () => {

  useHistory();


  return (
    <ScreenLayout>
      <AddOnOptionsContent />

      {/* 
      <MobileFooter handleContinueBooking={handleContinueBooking} showAddOn/> 
      */}
    </ScreenLayout>
  );
}

export default AddOnOptionsScreen;
